import React from 'react'
import { IconFitToScreenSize, IconFitToExtend } from 'components/Zui/Icon'
import { InteractiveIcon } from 'components/Zui'
import './imageViewerFooter.css'

const ImageViewerFooter = ({ onToggleFullscreen, isFullscreen, totalFiles, fileIndex }) => {
    return (
        <div className={`image-viewer-controls ${isFullscreen ? 'fullscreen-image-footer' : ''}`}>
            <div className="image-viewer-left-controls"></div>
            <div className="image-viewer-middle-controls">
                <div className="file-count-wrapper">
                    <span>
                        {fileIndex} / {totalFiles}
                    </span>
                </div>
            </div>
            <div className="image-viewer-right-controls">
                <div>
                    <InteractiveIcon
                        theme="zbds-dark"
                        className="zui-icon-wrapper"
                        onClick={onToggleFullscreen}
                    >
                        {isFullscreen ? (
                            <IconFitToScreenSize size="m" />
                        ) : (
                            <IconFitToExtend size="m" />
                        )}
                    </InteractiveIcon>
                </div>
            </div>
        </div>
    )
}

export default ImageViewerFooter
